<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M608jT/tc-custom/9781467439800.jpg?1715310754667" alt="This image is the cover for the book The Letters to the Colossians and to Philemon, The Pillar New Testament Commentary (PNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Letters to the Colossians and to Philemon, The Pillar New Testament Commentary (PNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>Exhibiting the same brilliant exegesis and sound practical insight found in his previous works, noted commentator Douglas J. Moo in this new volume not only explains accurately the meaning of the letters to the Colossians and to Philemon but also applies that meaning powerfully to twenty-first-century readers. Moo both interacts with the Greek text of these letters and clearly explains the English text to a contemporary audience.<br/><br/> Informed, evangelical, methodologically astute, and displaying a careful balance between good scholarship and pastoral concern -- earmarks of the Pillar New Testament Commentary series as a whole -- Moo's <i>Letters to the Colossians and to Philemon</i> will offer insights to a wide range of readers, from teachers and students, to pastors and parishioners, to scholars and laypersons.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas J. Moo
      </h2>
      
      <p class="authorDescription body article"><B>Douglas J. Moo</B> is professor emeritus of biblical studies at Wheaton College. His other commentaries include the New International Commentary on the New Testament volume on Romans and the Pillar New Testament Commentary volume on James. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f17338c